module.exports = __webpack_public_path__ + "static/character--keoni-no-slippers@3x.13bb0f89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/character--keoni-no-slippers@3x.png
// module id = 198
// module chunks = 6850842914447 126511778744290 216119991289378